import { PMPV2FooterContainer } from '../../PrescriptionMakingPageStyles'
import { PrescriptionFooter } from '../../PrescriptionMakingPageComponents'

export default function PrescriptionPrintableFooter({
  debugMode,
  prescriptionData,
  prescriptionParentDivDimensions,
  printType,
  footerHeight,
  leaveSpace,
  styleOverrides,
  useFullUrlForFooterImages,
}) {
  return (
    <PMPV2FooterContainer
      debug={debugMode}
      data-print-footer="true"
      style={{ 
        height: `${footerHeight}px`, 
        borderTop: leaveSpace ? '1px solid #000' : 'unset',
        flexShrink: 0,
        marginTop: 'auto', // Push footer to bottom of flex container
      }}
      prescriptionWidth={prescriptionParentDivDimensions?.width}
    >
      <PrescriptionFooter
        prescriptionData={prescriptionData}
        leaveSpace={leaveSpace}
        debug={debugMode}
        prescriptionWidth={prescriptionParentDivDimensions?.width}
        styleOverrides={styleOverrides}
        useCompleteImageLink={useFullUrlForFooterImages}
        footerHeight={footerHeight}
      />
    </PMPV2FooterContainer>
  )
}
